module.exports = __webpack_public_path__ + "d2f1c0fa68483c2161389a1e3f045238.pdf";